// extracted by mini-css-extract-plugin
export default {"offpeakDiscounts":"style--offpeakDiscounts--a2d42b","offpeakAppointments":"style--offpeakAppointments--932853","heading":"style--heading--ea218f","section":"style--section--d06b49"};